module.exports = __webpack_public_path__ + "static/banner-dadffd9d21ce767bb4eb35d1d22af5f5.jpg";